<template>
  <div>
    <p>
      <strong>Hours:</strong><br />
      Monday - Friday <br />
      7:30am-4:30pm EST
    </p>
    <p>
      <strong>Call Toll Free:</strong><br />
      1-888-404-9704
    </p>
    <p>
      <strong>Email:</strong><br />
      <a :class="`${linkClass}`" href="mailto:surveysupport@adi.org">SurveySupport@adi.org</a>
    </p>
  </div>
</template>

<script>
export default {
  name: "HelpBlock",
  props: {
      linkClass: String
  }
};
</script>
